<div class="paginaErrorPermiso">
  <img src="assets/img/logo.svg" alt="Conecta" class="logo">

  <div class="boxError">
    <img src="assets/img/imgSinAccion.png" class="img-fluid">
    <h4>SIN AUTORIZACIÓN</h4>
    <p>Tu usuario no tiene permisos asignados para esta aplicación. Ante cualquier duda, contáctese con su
      administrador.</p>
    <button class="btnRed" (click)="cerrarSesion()">CERRAR SESIÓN</button>
  </div>
</div>